import { NgModule, ErrorHandler, ModuleWithProviders } from "@angular/core";
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { ADPComponentsModule, ADPResourceService, ADPServicesModule, APP_DATE_FORMATS } from "digital-core";
import { GlobalErrorHandler } from "./handler/global-error-handler";
import { SiteConfigResolver } from "./resolvers";
import { PageResourcesResolver } from "./resolvers/page-resources.resolver";
import { CurrencyPipe, EmailMaskPipe, SecureAllPipe, SecureDataPipe,  } from 'digital-core';

export const ENV = 'ENV';

@NgModule({
    declarations: [],
    imports: [
      ADPComponentsModule,
      ADPServicesModule.forRoot(null)
     ],
    exports: [
      ADPComponentsModule
    ],
    providers: [
        ADPResourceService,
        PageResourcesResolver,
        SiteConfigResolver,
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: APP_DATE_FORMATS
        },
        { provide: MAT_DATE_LOCALE, useValue: window['config'].core.language },

        EmailMaskPipe, SecureDataPipe, SecureAllPipe, CurrencyPipe,


    ],
    bootstrap: []
})
export class ADPModule {
  static forRoot(environment: any): ModuleWithProviders<ADPModule>  {
      return {
          ngModule: ADPModule,
          providers: [
              {
                  provide: ENV,
                  useValue: environment
              }
          ]
      };
  }
}
